import React, { useState } from 'react';
import { Plus, Minus } from 'lucide-react';
import { faqs } from '../mock';

export default function FAQ() {
  const [open, setOpen] = useState(0);

  return (
    <section id="faq" className="relative py-24 md:py-36 border-t border-white/5">
      <div className="max-w-[1400px] mx-auto px-6 md:px-10">
        <div className="grid lg:grid-cols-[1fr_1.4fr] gap-12 lg:gap-24">
          <div>
            <div className="flex items-center gap-3 mb-6">
              <div className="w-10 h-px bg-[#e4cfaf]" />
              <span className="uppercase text-[11px] tracking-[0.28em] text-[#e4cfaf]/90">FAQ</span>
            </div>
            <h2 className="serif text-white text-4xl md:text-5xl leading-[1.05] mb-6">
              Questions landlords <span className="italic-serif">ask us most.</span>
            </h2>
            <p className="text-white/60 leading-relaxed">
              Still unsure about rent-to-rent or HMO management? Reach out and we&#39;ll walk you through it personally.
            </p>
          </div>

          <div className="divide-y divide-white/10 border-t border-white/10">
            {faqs.map((f, i) => {
              const isOpen = open === i;
              return (
                <div key={f.q}>
                  <button
                    onClick={() => setOpen(isOpen ? -1 : i)}
                    className="w-full text-left py-6 md:py-7 flex items-center justify-between gap-6 group"
                  >
                    <span className="serif text-white text-lg md:text-2xl group-hover:text-[#e4cfaf] transition-colors">
                      {f.q}
                    </span>
                    <span className="text-[#e4cfaf] shrink-0">
                      {isOpen ? <Minus className="w-5 h-5" /> : <Plus className="w-5 h-5" />}
                    </span>
                  </button>
                  <div
                    className={`grid transition-all duration-500 ease-in-out ${
                      isOpen ? 'grid-rows-[1fr] opacity-100 pb-7' : 'grid-rows-[0fr] opacity-0'
                    }`}
                  >
                    <div className="overflow-hidden">
                      <p className="text-white/60 leading-relaxed max-w-2xl">{f.a}</p>
                    </div>
                  </div>
                </div>
              );
            })}
          </div>
        </div>
      </div>
    </section>
  );
}
